import React, { useState, useCallback, useMemo, useEffect, createContext } from 'react'
import { useLocation } from 'react-router-dom'
import useMediaQuery from '@mui/material/useMediaQuery'
import Drawer from '@mui/material/Drawer'
import TopBar from './TopBar'
import NavBar from './NavBar'
import MobileBottomNavigation from './MobileBottomNavigation'
import { layoutMobileMediaQuery } from './layoutConstants'

export const LayoutContext = createContext({
  collapsed: false,
  toggleCollapse: () => {},
  isMobileLayout: false
})

const MainLayout = ({ children }) => {
  const location = useLocation()
  const isMobileLayout = useMediaQuery(layoutMobileMediaQuery)
  const [mobileNavOpen, setMobileNavOpen] = useState(false)

  const [collapsed, setCollapsed] = useState(() => {
    try {
      const saved = localStorage.getItem('collapsedState')
      return saved ? saved === 'true' : false
    } catch {
      return false
    }
  })

  // Rutas donde no se muestra el layout
  const noLayoutRoutes = [
    '/',
    '/logout',
    '/cambiar-contrasena',
    '/nueva-contrasena',
    '/verificar-correo',
    '/login/mfa',
    '/activate-account'
  ]
  const isPublicRoute =
    noLayoutRoutes.includes(location.pathname) || location.pathname.startsWith('/nueva-contrasena/')

  const toggleCollapse = useCallback(() => {
    setCollapsed((prev) => {
      const newState = !prev
      localStorage.setItem('collapsedState', String(newState))
      return newState
    })
  }, [])

  useEffect(() => {
    setMobileNavOpen(false)
  }, [location.pathname])

  useEffect(() => {
    if (!isMobileLayout) {
      setMobileNavOpen(false)
    }
  }, [isMobileLayout])

  const value = useMemo(
    () => ({ collapsed, toggleCollapse, isMobileLayout }),
    [collapsed, toggleCollapse, isMobileLayout]
  )

  if (isPublicRoute) return <>{children}</>

  return (
    <LayoutContext.Provider value={value}>
      <TopBar
        collapsed={collapsed}
        onToggleCollapse={toggleCollapse}
        isMobileLayout={isMobileLayout}
        onOpenMobileNav={() => setMobileNavOpen(true)}
      />
      <div
        className={`main-view ${collapsed ? 'collapsed' : ''} ${
          isMobileLayout ? 'main-view--mobile-shell' : ''
        }`}
      >
        {children}
      </div>

      {isMobileLayout ? (
        <Drawer
          anchor="left"
          open={mobileNavOpen}
          onClose={() => setMobileNavOpen(false)}
          PaperProps={{
            sx: {
              width: 280,
              boxSizing: 'border-box',
              overflowX: 'hidden',
              borderRight: '1px solid #DDE4EA',
              background:
                'radial-gradient(ellipse 80% 32% at 96% 10%, rgba(255, 143, 61, 0.09) 0%, transparent 58%), linear-gradient(180deg, #fff 0%, #f8fbff 52%, #eef3f8 100%)'
            }
          }}
        >
          <NavBar collapsed={false} embeddedInDrawer />
        </Drawer>
      ) : (
        <NavBar collapsed={collapsed} />
      )}
    </LayoutContext.Provider>
  )
}

export default React.memo(MainLayout)
